import React from "react";
import { Link } from "react-router-dom";

export default function TenantAdminSectionHeader({
  eyebrow = "Bedrijfsinrichting",
  title,
  description,
  backTo = "/tenant-admin",
  backLabel = "Terug naar Bedrijfsinrichting",
}) {
  return (
    <header className="mb-6 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <p className="text-xs uppercase tracking-[0.18em] text-slate-500">{eyebrow}</p>
      <h1 className="mt-1 text-2xl font-bold text-slate-900">{title}</h1>
      {description ? <p className="mt-2 text-sm text-slate-600">{description}</p> : null}
      <div className="mt-3">
        <Link to={backTo} className="text-sm font-medium text-slate-700 underline underline-offset-2">
          {backLabel}
        </Link>
      </div>
    </header>
  );
}
